/**
 * Rule Engine - Rule Definitions
 * Phase D: 6 default rules (R1-R6)
 */

export type RuleSeverity = 'block' | 'warn' | 'info';

export interface RuleDefinition {
  code: string;
  label: string;
  description: string;
  targetModule: string;
  sourceModule: string;
  severity: RuleSeverity;
  messageTemplate: string;
  conditionField?: string;         // e.g., 'gate', 'status' — indicates editable condition
  defaultConditionValue?: string;  // e.g., 'G3', 'Approved'
}

export const DEFAULT_RULES: RuleDefinition[] = [
  {
    code: 'R1',
    label: 'Drawing Gate ≥ G3',
    description: 'Bản vẽ Zone phải đạt G3 (For Construction) trước khi tạo Daily Plan',
    targetModule: 'execute',
    sourceModule: 'drawings',
    severity: 'warn',
    messageTemplate: 'Bản vẽ Zone {zone} chưa duyệt For Construction (hiện tại: {currentGate})',
    conditionField: 'gate',
    defaultConditionValue: 'G3',
  },
  {
    code: 'R2',
    label: 'Specs Zone Approved',
    description: 'Tất cả Specs trong Zone phải Approved trước khi tạo Daily Plan',
    targetModule: 'execute',
    sourceModule: 'specs',
    severity: 'warn',
    messageTemplate: 'Còn {count} specs Zone {zone} chưa Approved',
    conditionField: 'status',
    defaultConditionValue: 'Approved',
  },
  {
    code: 'R3',
    label: 'Method Statement Submitted',
    description: 'Method Statement hạng mục phải ≥ Submitted trước khi tạo Daily Plan',
    targetModule: 'execute',
    sourceModule: 'permit',
    severity: 'warn',
    messageTemplate: 'Method Statement cho "{entity}" chưa submit',
    conditionField: 'status',
    defaultConditionValue: 'submitted',
  },
  {
    code: 'R4',
    label: 'Subcontractor Evaluation',
    description: 'Phải có đánh giá nhà thầu trước khi thanh toán',
    targetModule: 'procurement',
    sourceModule: 'closing',
    severity: 'warn',
    messageTemplate: 'Chưa đánh giá nhà thầu "{entity}"',
  },
  {
    code: 'R5',
    label: 'Spec Approved cho PO',
    description: 'Spec tương ứng phải Approved trước khi tạo PO',
    targetModule: 'procurement',
    sourceModule: 'specs',
    severity: 'warn',
    messageTemplate: 'Spec "{entity}" chưa Approved',
    conditionField: 'status',
    defaultConditionValue: 'Approved',
  },
  {
    code: 'R6',
    label: 'Sign-off Milestone',
    description: 'Sign-off milestone phải xanh trước khi chuyển 100%',
    targetModule: 'plan',
    sourceModule: 'plan',
    severity: 'warn',
    messageTemplate: 'Chưa ký xác nhận milestone "{entity}"',
  },
];

export const getRuleByCode = (code: string): RuleDefinition | undefined =>
  DEFAULT_RULES.find(r => r.code === code);

export const getRulesByTarget = (targetModule: string): RuleDefinition[] =>
  DEFAULT_RULES.filter(r => r.targetModule === targetModule);
